import { useEffect, useState } from 'react';
import styles from './Waveform.module.css';

export const WAVEFORM_BARS = 48;
export const WAVEFORM_TICK_MS = 100;
const MIN_PX = 3;
const MAX_PX = 20;

interface IWaveformProps {
  getLevel: () => number;
}

/** Scrolling bars of the mic level, newest on the right. */
export function Waveform({ getLevel }: IWaveformProps) {
  const [levels, setLevels] = useState<number[]>(() => Array(WAVEFORM_BARS).fill(0));

  useEffect(() => {
    const id = setInterval(() => setLevels((prev) => [...prev.slice(1), getLevel()]), WAVEFORM_TICK_MS);
    return () => clearInterval(id);
  }, [getLevel]);

  return (
    <span className={styles.wave} aria-hidden="true">
      {levels.map((level, i) => (
        <i key={i} className={styles.bar} style={{ height: MIN_PX + level * (MAX_PX - MIN_PX) }} />
      ))}
    </span>
  );
}
